export enum GameMatchStatus {
	Scheduled = 'scheduled',
	StartingSoon = 'starting_soon',
	Live = 'live',
	Halftime = 'halftime',
	Suspended = 'suspended',
	Walkover = 'walkover',
	Retired = 'retired',
	Abandoned = 'abandoned',
	Cancelled = 'cancelled',
	Final = 'final',
}
